<!-- 视频小程序-推广链接列表 -->
<template>
<div>
	
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- <div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">视频小程序-推广链接列表</div> -->
		<div style="display: flex;align-items: center;flex-wrap: wrap;">
			<div class="screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<!-- <a-menu-item key="1"> <a-icon type="align-right" />渠道设置</a-menu-item>
						<a-menu-item key="3"> <a-icon type="align-right" />回传设置</a-menu-item> -->
						<a-menu-item key="4"> <a-icon type="align-right" />小程序设置</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
		<!-- 	<div class="screen-box">
				<div class="screen-label">渠道</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择"
					@change="handleChangeQ"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="item in channelSelect" :key="item.id" :value="item.channel_id">
					{{item.channel_name}}
					</a-select-option>
				</a-select>
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">渠道内容</div>
				<a-select
					mode="multiple"
					style="width: 240px"
					placeholder="请选择渠道内容"
					@change="handleChangeNR"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option  value="3">短剧</a-select-option>
					<a-select-option  value="4">小说小程序</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">小程序渠道</div>
				<a-select
					mode="multiple"
					style="min-width: 220px;max-width: 450px;"
					placeholder="请选择小程序渠道"
					@change="handleChangeV"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">小程序</div>
				<xcxSearchSelect ref="getXcxSelect" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_link_id" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接名称</div>
				<a-input v-model="r_name" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">巨量</a-select-option>
					<a-select-option value="5">腾讯</a-select-option>
					<a-select-option value="6">百度</a-select-option>
					<a-select-option value="7">快手</a-select-option>
					<a-select-option value="8">微博</a-select-option>
					<a-select-option value="2">OPPO</a-select-option>
					<a-select-option value="3">VIVO</a-select-option>
					<a-select-option value="4">华为</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
			<a-button @click="plTgLink" class="screen-box" type="primary">添加推广链接</a-button>
		</div>
	</div>
	</div>
	
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':check_width + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > sticky_index " class="table-th-cell"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':check_width + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index  && z_tem.type != 'name' && z_tem.type != 'applets_name' && z_tem.type != 'channel_name' && z_tem.type != 'token' && z_tem.type != 'bd_url' && z_tem.type != 'callback_url' && z_tem.type != 'hc_'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 推广链接名称 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'name'" @click="editChannel(item,4)" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					{{item[z_tem.type]}}
				</div>
				<!-- 小程序 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'applets_name'" @click="editChannel(item,3)" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					<template v-if="item.applets_name">{{item.applets_name}}</template>
					<template v-else-if="item.appid">{{item.appid}}</template>
					<template v-else>未设置</template>
				</div>
				<!-- 推广平台 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'channel_name'" @click="editChannel(item,1)" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					{{item.channel_name || "未设置(不回传)"}}
					<div v-if="item.channel_name.indexOf('腾讯') > -1" style="margin-top:3px;">
						<span v-if="item.put_type == 1" style="margin-right: 10px;">直投链路</span>
						<span v-else-if="item.put_type == 2" style="margin-right: 10px;">企微链路</span>
						
						<span v-if="item.put_type == 1 && item.callback_type == 1">直投新版方案</span>
						<span v-else-if="item.put_type == 2 && item.callback_type == 2">企微旧版方案</span>
						<span v-else-if="item.put_type == 2 && item.callback_type == 3">企微自研：点击监测IP匹配</span>
					</div>
				</div>
				<!-- 百度转化跟踪token -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'token'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.token" style="display: inline-block;">
						<a-tooltip placement="top">
							<template slot="title">
							  <span style="width: 600px;">{{item.token}}</span>
							</template>
							<div style="display: flex;align-items: center;color: #62a8ea;cursor: pointer;">
								<div @click="editChannel(item,2)">已设置token</div>
								<a-icon @click.stop="mkUrlCopy(item,3)" type="copy" style="font-size: 13px;margin-left: 9px;"/>
							</div>
						</a-tooltip>
					</div>
					<div v-else style="color: #62a8ea;cursor: pointer;" @click="editChannel(item,2)">未设置</div>
				</div>
				<!-- 百度营销通线索URL -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'bd_url'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.bd_url">
						<a-tooltip placement="top">
							<template slot="title">
							  <span style="width: 600px;">{{item.bd_url}}</span>
							</template>
							<div @click="mkUrlCopy(item,1)" style="display: flex;align-items: center;cursor: pointer;">
								百度营销通线索URL
								<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
							</div>
						</a-tooltip>
					</div>
				</div>
				
				<!-- 点击监测链接 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'callback_url'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.callback_url && item.channel_name.indexOf('百度') < 0">
						<template v-if="item.channel_name.indexOf('腾讯') > -1">
							<a-tooltip placement="top">
								<template slot="title">
								  <span style="width: 600px;">{{item.callback_url}}</span>
								</template>
								<div @click="mkUrlCopy(item,2)" style="display: flex;align-items: center;cursor: pointer;">
									直投链路
									<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
								</div>
							</a-tooltip>
							<div style="width: 100%;height: 5px;"></div>
							<a-tooltip placement="top">
								<template slot="title">
								  <span style="width: 600px;">{{item.tencent_qywx_url}}</span>
								</template>
								<div @click="mkUrlCopy(item,4)" style="display: flex;align-items: center;cursor: pointer;">
									企微链路
									<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
								</div>
							</a-tooltip>
						</template>
						<template v-else>
							<a-tooltip placement="top">
								<template slot="title">
								  <span style="width: 600px;">{{item.callback_url}}</span>
								</template>
								<div @click="mkUrlCopy(item,2)" style="display: flex;align-items: center;cursor: pointer;">
									点击监测链接
									<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
								</div>
							</a-tooltip>
						</template>
						
					</div>
				</div>
				<!-- 回传设置 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.type == 'hc_'" @click="setPlanHcbl(item)" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					<div v-if="item.config" style="display: flex;flex-wrap: wrap;align-items: center;">
						<div v-if="item.config.status == 1" style="margin-right: 7px;flex-shrink: 0;">
							<a-tag color="green">已启用</a-tag>
						</div>
						<div v-else style="flex-shrink: 0;margin-right: 7px;">
							<a-tag>未启用</a-tag>
						</div>
						
						<template v-if="item.config.report_per_type == 1">
							<div>
								固定序列
							</div>
							<div style="width: 100%;height: 5px;"></div>
							<div>比例：{{item.config.report_per}}</div>
							<div style="margin-left: 10px;">最低金额：{{item.config.report_money_limit || 0}}</div>
							<div 
								v-if="item.config.order_time_condition_type == 1" 
								style="margin-left: 10px;"
							>
								注册当日首充
							</div>
							<div 
								v-else-if="item.config.order_time_condition_type == 0" 
								style="margin-left: 10px;"
							>
								注册{{item.config.order_time_condition_n}}小时内首充
							</div>
						</template>
						<template v-else-if="item.config.report_per_type == 2">
							<div>自定义序列</div>
						</template>
					</div>
					<div v-else>
						未设置
					</div>
				</div>
			</template>
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>

	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      :title="`${pl_edit_title}编辑${edit_modal_title}`"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading" 
		  width="1000px" 
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
	    >
		<!-- <template v-else-if="edit_modal_title == '百度转化跟踪token'">
			<div class="screen-box" style="align-items: baseline;">
				<div class="screen-label" style="width: 120px;text-align: right;">百度转化跟踪token</div>
				
				<a-textarea
					style="width: 450px;"
					v-model="e_bd_token"
					placeholder="请输入"
					:auto-size="{ minRows: 4, maxRows: 10 }"
				/>
			</div>
		</template> -->
		<template v-if="edit_modal_title == '小程序'">
			<div class="screen-box" style="align-items: baseline;">
				<div class="screen-label" style="width: 120px;text-align: right;">小程序</div>
				
				<xcxSearchSelect ref="getXcxSelectB" :mode_type="'dan'" :s_width="'400px'" @handleChangeSelect="handleChangeJ"></xcxSearchSelect>
			</div>
		</template>
		<template v-else-if="edit_modal_title == '推广链接名称'">
			<div class="screen-box" style="align-items: baseline;">
				<div class="screen-label" style="width: 120px;text-align: right;">推广链接名称</div>
				
				<a-input v-model="e_link_name" allowClear placeholder="请输入" style="width: 500px;"/>
			</div>
		</template>
		
		<div v-show="pl_edit_title == '批量'" style="margin-bottom: 10px;margin-top: 15px;">已选的推广名称：</div>
		<div v-show="pl_edit_title == '批量'" style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
			<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
				<div style="width: 110px;text-align: right;">{{item.link_id}}</div>
				<span style="margin: 0 5px;"> — </span>
				<div style="width: 165px;">{{item.name}}</div>
			</div>
		</div>
	</a-modal>
	
	<!-- 回传设置侧边栏 -->
	<hcSetDrawer ref="getHcSetDrawer" @hc-request="hcRequestD"></hcSetDrawer>
	
	<!-- 推广平台侧边栏 -->
	<tgptDrawer ref="getTgptDrawer" @tgpt-request="tgptRequest"></tgptDrawer>
	
	<!-- 批量录入推广链接 -->
	<plEnterTgLink ref="getEnterTgLink" @pl-tg-link-ok="plTgLinkOk"></plEnterTgLink>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { putGzhList, putDataMenu, putGzhSetAppid, putGzhSetWechatid, putGzhSetUser, putGzhSetBd, putGzhSetShow, videoXcxList, videoXcxEdit, videoXcxReport, channelLists, selectXsVdApplets } from '@/request/api'
import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
import hcSetDrawer from './components/hcSetDrawer.vue'
import tgptDrawer from './components/tgptDrawer.vue'
import plEnterTgLink from '@/components/drawerCompont/plEnterTgLink.vue'
export default {
	name: 'putlinkXcx_',
	components: {
		xcxSearchSelect,hcSetDrawer,tgptDrawer, plEnterTgLink
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广链接ID", width:130, type:"link_id", },
				{title:"推广链接名称", width:180, type:"name", },
				{title:"渠道", width:130, type:"plat_channel", },
				{title:"小程序", width:120, type:"applets_name", },
				
				{title:"推广平台", width:160, type:"channel_name", },
				{title:"回传设置", width:320, type:"hc_", },
				{title:"点击监测链接", width:150, type:"callback_url", },
				
				// {title:"百度转化跟踪token", width:130, type:"token", },
				{title:"百度营销通线索URL", width:150, type:"bd_url", },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			table_scroll_width: 1000,
			search_button_loading: false,
			sticky_index: -1,
			
			r_page: 1,
			r_limit: 50,
			table_total: 0,
			my_channel: undefined,
			r_gzh_name:"", // 公众号名称
			r_channel_id: "", // 选择渠道
			r_admin_id: "", // 管理员
			r_have_auth: "", // 是否绑定运营公众号。1为是。2为否
			
			r_content_type: undefined, // 渠道内容
			r_vd_qd: [], // 小程序渠道
			r_appid: [], // 小程序
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			check_width: 50, // 表格内选择框的宽度
			
			// 筛选条件部分
			filterData: {
				op_id:{
					list: [{}],
				},
				media_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				vd_channel: {},
				mp_book_channel: {},
			}, // 筛选条件数组
			
			// 单个编辑弹窗
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			confirmLoading: false,
			e_appid: "", // 编辑appid请求需要的参数
			e_wechatid: "", // 编辑微信ID请求需要的参数
			e_id: "", // 编辑请求用的id
			e_url: "", // 巨量联调-广告点击Url
			e_appid: undefined, // 小程序appid
			
			r_name: null, // 推广名称
			r_link_id: undefined, // 推广链接Id
			r_channel_id: undefined, // 推广平台 1=巨量，2=oppo，3=vivo
			r_channel: undefined, // 渠道
			
			e_channel_id: undefined, // 编辑渠道
			e_link_id: "", // 推广链接id
			e_third_user: undefined, // 第三方代理商id
			
			e_bd_token: null, // 百度转化跟踪token-编辑
			e_bd_url: null, // 百度营销通线索URL-编辑
			
			e_link_name: null, // 推广链接名称
			
			// 回传是否批量
			h_type_pl: 0, // 0表示单个设置，1表示批量设置
			
			// 批量编辑title
			pl_edit_title: "",
			
			test_type: "", // 联调方式，华为or巨量
			hw_acc_id: "", // 华为账户id
			e_hw_url: "", // 华为联调-url
			
			channelSelect: [], // 渠道下拉选择数据
			zhChannelSelect: [], // 小说小程序渠道+短剧渠道合并到一起
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle, that.check_width)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
			
			let f_select = res.data.data.filter
			that.zhChannelSelect = { ...f_select.vd_channel.list, ...f_select.mp_book_channel.list }
		})
		
		// 获取小程序下拉
		this.$refs.getXcxSelect.getSelectData()
		
		// channelLists({
		// 	page: 1, 
		// 	limit: 10000,
		// 	type:"0",
		// }).then(res=>{
		// 	console.log("渠道列表",res.data.data.data);
		// 	that.channelSelect = res.data.data.data || []
			
		// })
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 选择推广平台
		handleChangeC(e){
			this.r_channel_id = e
		},
		// 选择渠道
		handleChangeQ(e){
			console.log("渠道",e);
			this.r_channel = e
		},
		// 编辑渠道
		handleChangeE(e){
			console.log(e);
			this.e_channel_id = e
		},
		// 第三方选择
		handleChangeF(e){
			console.log(e);
			this.e_third_user = e
		},
		// 华为账户
		handleChangeH(e){
			this.hw_acc_id = e
		},
		// 渠道内容
		handleChangeNR(e){
			this.r_content_type = e
		},
		// 小程序渠道
		handleChangeV(e){
			this.r_vd_qd = e
			// 获取小程序下拉
			this.$refs.getXcxSelect.getSelectData(e)
		},
		
		// 小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		// 编辑弹窗-小程序
		handleChangeJ(e){
			this.e_appid = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){
				that.selectedData = [] // 已选内容清空
				that.r_page = 1
			}
			let r_data = {
				page: that.r_page,
				limit: that.r_limit,
				
				name: that.r_name, // 推广名称
				link_id: that.r_link_id, // 链接id
				channel_id: that.r_channel_id, // 推广平台 1=巨量，2=oppo，3=vivo，4=华为
				// channel : that.r_channel, // 渠道
				
				content_type: that.r_content_type, // 渠道内容
				appid: that.r_appid, // 小程序
				
				plat_channel: that.r_vd_qd, // 小程序渠道
			}
			
			videoXcxList(r_data).then(res=>{
				console.log("搜索结果",res);
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
						if(res.gzh_report_config){
							if(res.gzh_report_config.bd_report_status == 1){
								res.bd_checked = true
							}
							else {
								res.bd_checked = false
							}
						}
						else {
							res.bd_checked = false
						}
					})
					
					// 每次请求重置批量选择的状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					
					
					that.search_button_loading = false
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = data
				}
				else {
					that.search_button_loading = false
					that.checkAll = false
					that.indeterminate = false
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false
					})
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
				
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},300)
			})
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 巨量链接复制
		mkUrlCopy(e,type){
			console.log(e);
			let that = this
			let uuu = ""
			if(type == 1){
				uuu = e.bd_url
			}
			else if(type == 2){
				uuu = e.callback_url
			}
			else if(type == 3){ // token
				uuu = e.token
			}
			else if(type == 4){ // 腾讯-企微链路
				uuu = e.tencent_qywx_url
			}
			this.$copyText(uuu).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		// 百度回传
		bdhcSwitch(e,index){
			let that = this
			console.log(e);
			// this.tableShowData[index].bd_checked = e
			putGzhSetBd({
				id: that.tableShowData[index].id
			}).then(res=>{
				console.log("百度回传",res);
				that.$message.success('操作成功');
				that.searchButton()
			})
		},
		// 是否展示
		tdShowSwitch(e,index){
			let that = this
			console.log(e);
			// this.tableShowData[index].bd_checked = e
			putGzhSetShow({
				id: that.tableShowData[index].id
			}).then(res=>{
				console.log("百度回传",res);
				that.$message.success('操作成功');
				that.searchButton()
			})
		},
		// 表格单元格内的编辑按钮
		tdEdit(e,index,type){
			// console.log(e);
			// console.log(index);
			// console.log(type);
			this.e_id = e.id
			if(type == "APPID"){
				this.e_appid = e.appid
			}
			else if(type == "微信ID"){
				this.e_wechatid = e.gzh_wechat_id
			}
			this.edit_modal_title = type
			this.edit_visible = true
		},
		
		
		// 显示编辑单个渠道弹窗
		editChannel(e,type){
			console.log("编辑单个渠道",e);
			let that = this
			this.my_channel = e.channel
			if(type == 1){
				this.$refs.getTgptDrawer.getShowDrawer(e)
				return
				
				// this.edit_modal_title = '推广平台'
				// if(e.channel_id){
				// 	this.e_channel_id = e.channel_id.toString()
					
				// 	if(e.channel_id == 6 && e.token){
				// 		this.e_bd_token = e.token.toString() || ""
				// 	}
				// }
			}
			else if(type == 2){
				// this.edit_modal_title = '百度转化跟踪token'
				// if(e.token){
				// 	this.e_bd_token = e.token.toString()
				// }
			}
			else if(type == 3){ // 编辑小程序
				this.edit_modal_title = '小程序'
				this.e_appid = e.appid || undefined
			}
			else if(type == 4){ // 编辑推广链接名称
				this.edit_modal_title = '推广链接名称'
				this.e_link_name = e.name || null
			}
			
			this.e_link_id = e.link_id
			
			this.edit_visible = true
			
			if(type == 3){ // 要等弹窗已经出来了，节点已经有了之后，再执行下面的代码，不然获取不到DOM节点，就无法执行了
				that.$nextTick(()=>{
					// 获取小程序下拉
					that.$refs.getXcxSelectB.getSelectData()
					that.$refs.getXcxSelectB.setValue(this.e_appid)
				})
				
			}
		},
		// 第三方账户/代理商
		editThird(e){
			this.edit_modal_title = '第三方'
			this.e_link_id = e.link_id
			if(e.third_user){
				this.e_third_user = e.third_user.toString()
			}
			else {
				this.e_third_user = undefined
			}
			if(e.channel_id){ 
				this.e_channel_id = e.channel_id.toString()
			}
			this.edit_visible = true
		},
		// 编辑弹窗确认按钮
		editModalOk(){
			let that = this
			
			let r_data = {}
			// 如果为批量的话，link_id要传数组
			if(that.pl_edit_title == "批量"){
				// console.log("批量操作");
				let i_data = []
				let i_channel = []
				that.selectedData.forEach(res=>{
					i_data.push(res.link_id)
					i_channel.push(res.channel)
				})
				// console.log("i_data",i_data);
				r_data.link_id = i_data
				r_data.channel = i_channel
			}
			else { // 单个编辑
				r_data.link_id = that.e_link_id // 推广链接id
				r_data.channel = that.my_channel
			}
			
			if(that.edit_modal_title == "推广平台"){
				if(!that.e_channel_id){
					that.$message.warning('请先选择推广平台');
					return
				}
				r_data.channel_id = that.e_channel_id // 推广平台id，1=巨量，2=oppo，3=vivo
				if(that.e_channel_id == 6){
					r_data.token = that.e_bd_token
				}
			}
			else if(that.edit_modal_title == "百度转化跟踪token"){
				if(!that.e_bd_token){
					that.$message.warning('请先填写百度转化跟踪token');
					return
				}
				r_data.token = that.e_bd_token
			}
			else if(that.edit_modal_title == "小程序"){
				r_data.appid = that.e_appid
			}
			else if(that.edit_modal_title == "推广链接名称"){
				if(!that.e_link_name){
					that.$message.warning('推广链接名称不能为空');
					return
				}
				r_data.name = that.e_link_name
			}
			
			that.confirmLoading = true
			
			videoXcxEdit(r_data).then(res=>{
				console.log("编辑渠道请求",res);
				that.confirmLoading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.editModalCancel()
					that.$message.success('编辑成功');
					that.searchButton()
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
			
		},
		// 编辑弹窗取消
		editModalCancel(){
			// if(this.confirmLoading){
			// 	return
			// }
			
			this.e_channel_id = undefined
			this.e_third_user = undefined
			
			this.pl_edit_title = "" // 批量状态清空
			
			this.test_type = "" // 联调状态清空
			this.e_hw_url = "" // 华为联调url
			this.hw_acc_id = undefined // 华为联调选择的账号
			
			this.e_hap_url = "" // HAP链接
			
			this.edit_visible = false
			
			this.confirmLoading = false
			
			this.e_bd_token = null // 百度转化跟踪token-编辑
		},
		
		// 计划回传比例侧边栏开始
		setPlanHcbl(e){
			if(!e.channel_id){
				this.$message.warning('请先设置推广平台');
				return
			}
			this.$refs.getHcSetDrawer.setPlanHcbl(e)
		},
		// 回传侧边栏组件确认按钮 传递过来 的要执行的操作
		hcRequestD(r_data){
			let that = this
			videoXcxReport(r_data).then(res=>{
				
				that.$refs.getHcSetDrawer.closeLoading()
				
				console.log('确认设置回传',res)
				if(res.data.code == 0){
					
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.$refs.getHcSetDrawer.hcCloseDrawer()
					
					that.$message.success('设置成功');
					that.searchButton()
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
				
			})
			.catch(err=>{
				that.$refs.getHcSetDrawer.closeLoading()
				
				that.$message.error(`错误：${err}`)
			})
		},
		
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				that.pl_edit_title = "批量"
				if(e.key == '1'){ // 渠道设置
					that.edit_modal_title = "推广平台"
					that.edit_visible = true
				}
				else if(e.key == '3'){ // 回传设置
					that.h_type_pl = 1
					that.hc_visible = true
				}
				else if(e.key == '4'){ // 小程序设置
					that.edit_modal_title = "小程序"
					that.edit_visible = true
					
					that.$nextTick(()=>{
						// 获取小程序下拉
						that.$refs.getXcxSelectB.getSelectData()
					})
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		
		// hap链接复制
		hapUrlCopy(e){
			let that = this
			this.$copyText(e.hap_url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		
		
		// 推广平台侧边栏
		tgptRequest(){
			this.searchButton()
		},
		
		plTgLink(){
			this.$refs.getEnterTgLink.getShowDrawer()
		},
		plTgLinkOk(){
			this.searchButton()
		},
	},
	filters: {
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}
</style>